export default __webpack_public_path__ + "static/media/b3.328bee4c.png";